import { render, staticRenderFns } from "./EditPresentacion.vue?vue&type=template&id=50f46bae&scoped=true"
import script from "./EditPresentacion.vue?vue&type=script&lang=js"
export * from "./EditPresentacion.vue?vue&type=script&lang=js"
import style0 from "./EditPresentacion.vue?vue&type=style&index=0&id=50f46bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f46bae",
  null
  
)

export default component.exports